module.exports = __webpack_public_path__ + "img/logo-or-menachem-banot.77ca5772.png";